import React from "react";
import { NavBar, Avatar } from 'antd-mobile'

import { 
    BodyView,
    ListView,
} from "../../factory/ViewUtil";

import { CellCardView } from "../../factory/CellViews";
import { avatarData } from "../../../NetworkFactory";

const MeProfileViewController = ({goback, navpush, user}) => {

    return(
        <>
             <div className='fixed-nav-bar'>
                <NavBar onBack = {goback}>My Profile</NavBar>
            </div>
            <BodyView style={{paddingTop : '52px'}}>
               <ListView>
                    <CellCardView onClick={()=> {navpush('./editavatar')}} style={{marginTop : '20px'}} extra={<Avatar src={avatarData()}/> }>Profile Photo</CellCardView>
                    <CellCardView onClick={()=> {navpush('./editname')}} extra={user.name}>Name</CellCardView>
               </ListView>
            </BodyView>
        </>
    );
}
export default React.memo(MeProfileViewController)